import styled from 'styled-components';
import {CssRule} from "../../../../themes/architecture/css-helpers/css-rule";

export const DialogIconWrapperDefaultBox = styled.div`
    text-align: center;
    color: ${({theme}) => theme.colors.brandPrimary };
    margin: 2em auto;
    
    @media ${({theme}) => theme.mediaQuery.veryLowHeight} {
        ${CssRule.For.mobile.landscape.build()} & {
            margin: 0 auto;
        }
    }
`;
